module.exports = "<p>\r\n  applicant-preview-basic works!\r\n</p>\r\n"